import React from 'react'
import { components, MenuListProps } from 'react-select'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'

const useStyles = makeStyles((theme) => ({
  menuListButton: {
    color: theme.primary,
    padding: '8px 12px',
    cursor: 'pointer',
    fontWeight: 600,
    borderBottom: `1px solid ${theme.primary}`,
  },
}))

interface IMenuListWithCreate extends MenuListProps {
  onCreateClick: () => void
}

const MenuListWithCreate = ({ onCreateClick, ...props }: IMenuListWithCreate) => {
  const classes = useStyles()

  return (
    <components.MenuList {...props}>
      <div
        onClick={onCreateClick}
        className={classes.menuListButton}
      >
        + {lang.generics.new}
      </div>
      {props.children}
    </components.MenuList>
  )
}

export default MenuListWithCreate
